<template>
  <div :class="['pt-10 pb-5 component-div', isRTLlang(lang) ? 'rtl mrgn-rt-25' : '']">
    <b-row>
      <b-col cols="12" class="pl-14 d-flex" v-if="isDisplayQuestionInfo">
        <div class="number-sequence" :class="isFieldDisabled ? 'disable-question' : ''">
          <span class="cursor_pointer1" v-if="(activityInfo.showNumericLabels || activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null || componentData.sequence) && activityInfo.showNumericLabels">{{ componentData.stepSequence ? componentData.stepSequence : componentData.sequence }} </span>
          <span class="cursor_pointer1" v-else-if="componentData.sequence && (activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null)">{{ componentData.sequence }} </span>
        </div>
        <span
          :class="['question-tital-name ml-2', isRTLlang(lang) ? 'rtl' : '', isFieldDisabled ? 'disable-question' : '']"
          v-translate:_formattedBody="{
            key: translationKeyInitial,
            val: lang,
            html: componentData.formattedBody
          }"
          v-html="componentData.formattedBody"
        ></span>

        <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" :class="isFieldDisabled ? 'disable-question' : ''" v-if="componentData.isSkippable" v-translate:_optional="{ key: 'label', val: lang, html: 'Optional' }">Optional</span>

        <span v-if="isFieldDisabled" class="skipped-question-box ml-15 d-inline-box pt-2 nonOpaque" v-translate:_skipped="{ key: 'label', val: lang, html: 'Skipped' }">Skipped</span>

        <div class="ml-5" v-if="componentData && componentData.notifications && componentData.notifications.length > 0 && isNotificationIcon">
          <img alt="Bell icon" src="@/assets/NotificaionIcon.png" data-v-c76994f4 />
        </div>
        <span
          class="text-warning pl-15 fw-bold"
          v-translate:_required="{
            key: 'validation_error',
            val: lang,
            html: 'This field is required.'
          }"
          v-if="hasWarningError"
          >This field is required.</span
        >
        <span
          class="text-danger pl-15 fw-bold"
          v-translate:_required="{
            key: 'validation_error',
            val: lang,
            html: 'This field is required.'
          }"
          v-else-if="hasFieldError"
          >This field is required.</span
        >
        <span
          class="text-danger pl-15 fw-bold"
          v-translate:_required="{
            key: 'validation_error',
            val: lang,
            html: 'This field is required.'
          }"
          v-else-if="errors.has(`booleanPreview-${componentData.id}`)"
          >This field is required.</span
        >
      </b-col>
    </b-row>

    <!-- PREVIEW MODE -->
    <template v-if="mode == 0">
      <b-row class="pl-45 pt-10">
        <b-form-group>
          <b-form-radio-group name="activityFormBooleanPreview" disabled stacked>
            <b-form-radio v-for="option in componentData.options" :key="option.id" :value="option.id">
              <span
                v-translate:_formattedBody="{
                  key: translationKeyInitial,
                  val: lang,
                  optionId: option.id,
                  optionLable: '_options_',
                  html: option.formattedBody
                }"
                v-html="option.formattedBody"
              ></span>
            </b-form-radio>
          </b-form-radio-group>
        </b-form-group>
        <span class="text-warning pl-15 fw-bold" v-if="hasWarningError">This field is required.</span>
        <span class="text-danger pl-15 fw-bold" v-else-if="hasFieldError">This field is required.</span>
        <b-col cols="8"></b-col>
      </b-row>
    </template>

    <!-- EDIT MODE -->
    <template v-else-if="mode == 1">
      <b-row class="pl-53" :class="isFieldDisabled ? 'disable-question' : ''">
        <b-form-group class="mb-5 radio-boolean-label">
          <b-form-radio-group v-bind:class="isRTLlang(lang) ? 'rtl radio-position-inline' : ''" v-model="componentData.answerId" v-validate="!componentData.isSkippable && (isFieldDisabled == false || isFieldDisabled == undefined) ? 'required' : ''" @change="onAnswerChange" :disabled="isFieldDisabled" stacked>
            <b-form-radio v-for="option in componentData.options" :key="option.id" :value="option.id">
              <span
                class="radio-mrgn-5"
                v-translate:_formattedBody="{
                  key: translationKeyInitial,
                  val: lang,
                  optionId: option.id,
                  optionLable: '_options_',
                  html: option.formattedBody
                }"
                v-html="option.formattedBody"
              ></span>
            </b-form-radio>
          </b-form-radio-group>
          <div v-if="isRTLlang(lang)" class="float-right">
            <span class="activity-form__clear pl-55" :class="{ clearOptionDisabled: isFieldDisabled }" v-translate:_CLEAR="{ key: 'BUTTON', val: lang, html: 'Clear' }" @click="clearAnswer">Clear</span>
            <div class="d-inline-block ml-18" v-if="activityInfo.canScoreResponses">
              <label class="fs-12 pl-5" v-translate:_score="{ key: 'label', val: lang, html: 'Score' }">Score</label>
              <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                {{ componentData && componentData.answerId ? componentData.actualScore : showScore(componentData.skipScore) }}
              </div>
            </div>
          </div>
        </b-form-group>
        <b-col cols="8"></b-col>
      </b-row>
      <div v-if="lang != 'he' && lang != 'ar-IL'" :class="isFieldDisabled ? 'disable-question' : ''">
        <span class="activity-form__clear pl-55" :class="{ clearOptionDisabled: isFieldDisabled }" v-translate:_CLEAR="{ key: 'BUTTON', val: lang, html: 'Clear' }" @click="clearAnswer">Clear</span>
        <div class="d-inline-block ml-18" v-if="activityInfo.canScoreResponses">
          <label class="fs-12 pl-5" v-translate:_score="{ key: 'label', val: lang, html: 'Score' }">Score</label>
          <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
            {{ componentData && componentData.answerId ? componentData.actualScore : showScore(componentData.skipScore) }}
          </div>
        </div>
      </div>
    </template>

    <!-- RESPONSE MODE -->
    <template v-else-if="mode == 2">
      <span :class="{ 'query-icon': isEdited }"></span>
      <b-row>
        <b-col :class="componentData.isEditedVersion ? 'col-6' : 'col-10'" class="pl-30">
          <span class="changed" v-if="componentData.isEditedVersion"></span>
          <div
            v-if="componentData.answerId"
            v-translate:_formattedBody="{
              key: translationKeyInitial,
              val: lang,
              optionId: componentData.answerId,
              optionLable: '_options_',
              html: componentData.answer
            }"
            v-html="componentData.answer"
            :class="['answers ml-16', isRTLlang(lang) ? 'float-right' : '']"
          />
          <div v-else>{{ componentData.answer }}</div>
          <div v-if="isRTLlang(lang)" :class="[isRTLlang(lang) ? 'clearfix' : '']"></div>
          <b-row class="pt-5">
            <div class="d-inline-block ml-16" v-if="activityInfo.canScoreResponses">
              <label class="pl-5" v-translate:_score="{ key: 'label', val: lang, html: 'Score' }">Score</label>
              <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                {{ componentData && componentData.answerId ? componentData.actualScore : showScore(componentData.skipScore) }}
              </div>
            </div>
          </b-row>
        </b-col>
        <b-col v-if="componentData.isEditedVersion" class="col-6 previous-answer">
          <span class="previous-value-mark"></span>
          <div
            class="answers previous-value"
            v-translate="{
              key: 'label_previous_value',
              val: lang,
              html: 'Previous value'
            }"
          >
            Previous value
          </div>
          <div>{{ componentData.previousAnswer }}</div>
          <b-row class="pt-5" v-if="componentData.previousAnswer">
            <div class="d-inline-block" v-if="activityInfo.canScoreResponses">
              <label v-translate:_score="{ key: 'label', val: lang, html: 'Score' }">Score</label>
              <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                {{ showScore(componentData.previousActualScore) }}
              </div>
            </div>
          </b-row>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import langTranslate from "./lang-translate";

export default {
  name: "activity-form-boolean-preview",

  data() {
    return {
      hasFieldError: false,
      fieldErrorText: "",
      hasWarningError: false,
      fieldWarningText: "",
      scoresMap: {}
    };
  },

  mixins: [langTranslate],

  props: {
    componentData: {},
    isDisplayQuestionInfo: {
      default: true
    },
    isFieldDisabled: {
      type: Boolean,
      default: false
    },
    mode: {
      default: 0
    },
    isEdited: null,
    activityInfo: {
      default: () => {}
    },
    triggerValidate: {
      type: Boolean,
      default: false
    },
    isNotificationIcon: Boolean,
    nextStepSequence: null,
    isClearData: {
      type: Boolean,
      default: false
    },
    lang: String
  },
  watch: {
    triggerValidate() {
      if (!this.isFieldDisabled) {
        if (!this.componentData.isSkippable && !this.componentData.answerId) {
          this.hasFieldError = true;
        }
        this.$validator.validateAll();
      }
    },
    isFieldDisabled(val) {
      if (val === true && this.componentData.branchingConfigured && !!this.componentData.answerId && !!this.nextStepSequence && this.nextStepSequence === this.componentData.stepSequence + 1) {
        this.clearAnswer();
      } else if (val === true) {
        this.resetField();
      }
    },
    isClearData: {
      deep: true,
      handler(val) {
        if (val === true) {
          this.clearAnswer();
        }
      }
    }
  },
  methods: {
    isRTLlang(lang) {
      return lang == "he" || lang == "ar-IL";
    },
    isScoreExcluded(answer) {
      let excludeScore = false;
      const option = this.componentData.options.find(option => option.body == answer);
      if (option) {
        excludeScore = option.excludeScore;
      }
      return excludeScore;
    },
    showScore(score) {
      if (score) {
        return score;
      }
      return 0;
    },
    resetAllErrors() {
      this.hasFieldError = false;
      this.fieldErrorText = "";
      this.hasWarningError = false;
      this.fieldWarningText = "";
    },
    resetField() {
      this.componentData.answerId = undefined;
      this.componentData.computedScore = 0;
      this.componentData.actualScore = 0;
      this.errors.clear();
      this.resetAllErrors();
      this.$emit("getQuestionScores");
    },
    clearAnswer() {
      this.resetField();
      this.checkForFieldErrors();
      this.$emit("onClearAnswer", this.componentData);
    },
    onAnswerChange(e) {
      this.$nextTick(() => {
        this.onChangeOptions(e);
        this.$emit("onAnswerChange", this.componentData);
      });
    },
    onChangeOptions(e) {
      this.componentData.dataChecks = [];
      this.checkForFieldErrors();
      this.componentData.computedScore = this.scoresMap[e];
      this.componentData.actualScore = this.scoresMap[e];
    },
    calculateScoresMap() {
      if (this.componentData.options) {
        this.componentData.options.forEach(option => {
          this.scoresMap[option.id] = option.score || 0;
        });
      }
    },
    checkForFieldErrors() {
      this.hasWarningError = false;
      this.hasFieldError = false;
      this.componentData.dataChecks = [];
      if (this.componentData.dataEditChecks) {
        let softDataCheck = false;
        for (let k = 0; k < this.componentData.dataEditChecks.length; k++) {
          if (this.componentData.dataEditChecks[k].check == "SOFT") {
            if (this.componentData.dataEditChecks[k].type == "NOT_BLANK" && (this.componentData.answerId == "" || this.componentData.answerId == undefined || this.componentData.answerId == null)) {
              this.fieldWarningText = "This field is required.";
              this.hasWarningError = true;
              softDataCheck = true;
              this.componentData.dataChecks.push({
                dataCheckId: this.componentData.dataEditChecks[k].id,
                dataCheckType: this.componentData.dataEditChecks[k].type,
                message: `This field is required.`
              });
            }
          } else {
            if (this.componentData.dataEditChecks[k].type == "NOT_BLANK" && (this.componentData.answerId == "" || this.componentData.answerId == undefined || this.componentData.answerId == null)) {
              this.fieldWarningText = "";
              this.hasWarningError = false;
              this.hasFieldError = true;
              //this.componentData.isSkippable = false;
            }
          }
        }
        if (softDataCheck) {
          return false;
        }
      }
    }
  },
  mounted() {
    try {
      this.calculateScoresMap();
    } catch (e) {}
    if (this.mode == 1) {
      this.$emit("initAnswerChange", this.componentData);
    }
    if (this.mode == 0 || this.mode == 2) {
      if (this.componentData.isSkippable && this.componentData.answer == "") {
        this.componentData.actualScore = this.componentData.skipScore;
        this.componentData.computedScore = this.componentData.skipScore;
      }
    }
    if (this.mode == 2) {
      if (this.componentData.isSkippable && this.componentData.answer == "") {
        this.componentData.previousActualScore = this.componentData.skipScore;
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/edit-site-partcipant-activity.scss";
.activity-form-preview {
  &__date-dropdown {
    width: 100px;
  }
  &__time-disabled {
    line-height: 1.8;
    color: #495057;
    background-color: #e9ecef;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    height: 40px;
    border-radius: 0.25rem;
    font-size: 15px;
    width: 100px;
  }
}
.component-div:hover .icons-div {
  display: block;
}
.changed {
  position: absolute;
  left: 0;
  top: 0;
  width: 10px;
  height: 60px;
  border-radius: 1px;
  background-color: #ffa200;
}

.previous-value-mark {
  width: 3px;
  height: 65px;
  background-color: #ffa200;
  border-radius: 1px;
  left: 0;
  top: 4px;
  position: absolute;
}

.answers {
  font-weight: 600;
}

.previous-answer {
  opacity: 0.8;
}

.previous-value {
  color: #ffa200;
  opacity: 0.8;
  font-size: 10px;
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: 9px;
  letter-spacing: 2.4px;
  margin-top: 3px;
}
.activity-form__clear {
  width: 29px;
  height: 14px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #4c8ce4;
}
.number-sequence {
  min-width: 30px;
  display: inline-block;
}

.component-div {
  border-top: 1px solid #fefefe;
  border-bottom: 1px solid #d3dfe4;
}
.clearOptionDisabled {
  pointer-events: none !important;
}
.question-tital-name {
  word-break: break-word;
}
</style>
